__webpack_require__.p = "https://linguistica.algovicrm.com/";